import React from 'react';
import { styled } from "../../stitches.config";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TABOOLA_SKELETON } from "../../components/common/constants/constants";

interface TaboolaSkeletonProps {
    numberOfBoxes: number;
}

const TaboolaSkeleton: React.FC<TaboolaSkeletonProps> = ({ numberOfBoxes }) => {

    const taboolaSkeletonsNumber: number = (TABOOLA_SKELETON === 3 || TABOOLA_SKELETON === 4) ? TABOOLA_SKELETON : numberOfBoxes;

    const renderBoxes = () => {
        const boxes = [];
        for (let index = 0; index < taboolaSkeletonsNumber; index++) {
            boxes.push(
                <TaboolaSkeletonBox bigSizeBox={taboolaSkeletonsNumber === 3}>
                    <TaboolaSkeletonImage bigSizeBox={taboolaSkeletonsNumber === 3}>
                        <Skeleton height="100%" />
                    </TaboolaSkeletonImage>
                    <TaboolaSkeletonText>
                        <Skeleton count={2} height="25px" style={{ marginBottom: "5px" }} />
                    </TaboolaSkeletonText>
                </TaboolaSkeletonBox>
            )
        }
        return boxes;
    };
    return (
        <>
            <TaboolaSkeletonTitle>Polecane artykuły</TaboolaSkeletonTitle>
            <TaboolaSkeletonWrapper>{renderBoxes()}</TaboolaSkeletonWrapper>
        </>

    );
};
const TaboolaSkeletonTitle = styled('div', {
    fontSize: "34px",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    padding: "40px 0px 40px 0px",
    color: "$grayscale100",
    "@desktop": {
        fontSize: "38px",

    }
})
const TaboolaSkeletonWrapper = styled('div', {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    "@desktop": {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "2%"
    }
})
const TaboolaSkeletonBox = styled('div', {
    width: "100%",
    minHeight: "320px",
    "@desktop": {
        minHeight: "291px",
        marginBottom: "2%",
        float: "left",
    },

    variants: {
        bigSizeBox: {
            true: {
                "@desktop": {
                    width: "32%",
                }
            },
            false: {
                "@desktop": {
                    width: "23.5%",
                }
            }
        }
    },
});
const TaboolaSkeletonImage = styled('div', {
    width: "100%",
    height: "234px",
    marginBottom: "5px",

    variants: {
        bigSizeBox: {
            true: {
                "@desktop": {
                    height: "200px",
                },
                "@bp5": {
                    height: "270px",
                }
            },
            false: {
                "@desktop": {
                    height: "148px",
                },
                "@bp5": {
                    height: "199px",
                }
            }
        }
    },
})
const TaboolaSkeletonText = styled('div', {
    width: "100%",
    lineHeight: "1"
})
export default TaboolaSkeleton